"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RadioButton = exports.RADIO_BUTTON_STYLES = exports.Input = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _styledIs = _interopRequireWildcard(require("styled-is"));
var _variables = require("../../styles/variables");
var _HBCheckbox = require("../HBCheckbox/HBCheckbox.styles");
var _colors = _interopRequireDefault(require("../../styles/colors"));
var _mixins = require("../../styles/mixins");
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var RADIO_BUTTON_STYLES = exports.RADIO_BUTTON_STYLES = {
  checked: {
    on: {
      background: "".concat(_colors["default"].neutral900),
      borderColor: "".concat(_colors["default"].neutral900)
    },
    off: {
      background: "".concat(_colors["default"].white),
      borderColor: "".concat(_colors["default"].neutral600)
    }
  },
  xs: {
    outerCircle: '16px',
    innerCircle: '6px'
  },
  sm: {
    outerCircle: '20px',
    innerCircle: '8px'
  },
  md: {
    outerCircle: '24px',
    innerCircle: '10px'
  },
  lg: {
    outerCircle: '24px',
    innerCircle: '10px'
  },
  xl: {
    outerCircle: '24px',
    innerCircle: '10px'
  }
};
function getCustomTheme(_ref) {
  var background = _ref.background;
  return (0, _styledComponents.css)(["background:", ";border-color:", ";"], background, background);
}
var Input = exports.Input = _styledComponents["default"].input.withConfig({
  displayName: "HBRadioButtonstyles__Input",
  componentId: "sc-kkwpc0-0"
})(["cursor:pointer;appearance:none;margin:0 !important;", " background-color:transparent;width:", ";height:", ";border-width:1px;border-style:solid;box-sizing:border-box;border-radius:50%;&:focus,&:hover{outline:none;border-color:", ";}", " ", " ", " ", " ", " &:after{content:'';border-radius:inherit;background:", ";opacity:", ";width:", ";height:", ";", "}"], _mixins.inlineFlexCenterAll, function (props) {
  return RADIO_BUTTON_STYLES[props.radioSize].outerCircle;
}, function (props) {
  return RADIO_BUTTON_STYLES[props.radioSize].outerCircle;
}, _colors["default"].neutral700, (0, _styledIs.isNot)('disabled')(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n            ", "\n    "])), _variables.BOX_SHADOW.checkbox["default"]), (0, _styledIs.isNot)('customTheme')(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n            ", "\n    "])), function (props) {
  return props.checked ? RADIO_BUTTON_STYLES.checked.on : RADIO_BUTTON_STYLES.checked.off;
}), (0, _styledIs["default"])('checked')(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n        ", "\n    "])), _variables.BOX_SHADOW.checkbox.checked), (0, _styledIs["default"])('customTheme')(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2["default"])(["\n        ", ";\n    "])), function (props) {
  return props.checked ? getCustomTheme(props.customTheme) : RADIO_BUTTON_STYLES.checked.off;
}), (0, _styledIs["default"])('disabled')(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2["default"])(["\n        ", "\n    "])), _HBCheckbox.getCheckboxDisabledStyles), _colors["default"].white, function (props) {
  return props.checked ? 1 : 0;
}, function (props) {
  return RADIO_BUTTON_STYLES[props.radioSize].innerCircle;
}, function (props) {
  return RADIO_BUTTON_STYLES[props.radioSize].innerCircle;
}, (0, _styledIs["default"])('customTheme')(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2["default"])(["\n          background:  ", "\n        "])), function (props) {
  return props.customTheme.color || _colors["default"].white;
}));
var RadioButton = exports.RadioButton = _styledComponents["default"].div.withConfig({
  displayName: "HBRadioButtonstyles__RadioButton",
  componentId: "sc-kkwpc0-1"
})(["", " display:inline-flex;align-items:center;", ""], _mixins.hideInPrint, (0, _styledIs["default"])('isDisabled')(_templateObject7 || (_templateObject7 = (0, _taggedTemplateLiteral2["default"])(["\n        pointer-events: none;\n    "]))));
//# sourceMappingURL=HBRadioButton.styles.js.map